var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.899,
    height: 15.899,
    viewBox: "0 0 15.899 15.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2179",
    "data-name": "Path 2179",
    d: "M7.949,15.9a7.95,7.95,0,1,1,7.95-7.95,7.958,7.958,0,0,1-7.95,7.95m0-14.4A6.45,6.45,0,1,0,14.4,7.949,6.457,6.457,0,0,0,7.949,1.5",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2180",
    "data-name": "Path 2180",
    d: "M7.95,12.25a1,1,0,1,1,1-1,1,1,0,0,1-1,1",
    fill: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2181",
    "data-name": "Path 2181",
    d: "M7.949,9.5a.75.75,0,0,1-.75-.75V7.35a.75.75,0,0,1,.75-.75A.981.981,0,0,0,9,5.55.983.983,0,0,0,7.942,4.5.979.979,0,0,0,6.9,5.55a.75.75,0,0,1-1.5,0A2.478,2.478,0,0,1,7.949,3,2.479,2.479,0,0,1,10.5,5.55,2.4,2.4,0,0,1,8.7,7.989V8.75a.75.75,0,0,1-.75.75",
    fill: "#7d7d7d"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.337ca2806de91b49254787f76517597a.svg";
export { ForwardRef as ReactComponent };